import { Card, CardContent, CardHeader, CardTitle } from "../components/ui/card";
import { CreditCard, ExternalLink } from "lucide-react";
import { Button } from "../components/ui/button";

const cards = [
  { name: "OpenSky Secured", type: "Secured", deposit: "$200", apr: "22.54%", link: "https://openskycc.com" },
  { name: "Chime Credit Builder", type: "Secured", deposit: "$0", apr: "0%", link: "https://chime.com" },
  { name: "Discover it Secured", type: "Secured", deposit: "$200", apr: "27.24%", link: "https://discover.com" },
  { name: "Capital One Platinum", type: "Unsecured", deposit: "None", apr: "30.74%", link: "https://capitalone.com" },
];

export default function CardRecommendations() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold">Credit Card Recommendations</h1>
        <p className="text-zinc-400">Cards to help rebuild credit</p>
      </div>
      <div className="grid md:grid-cols-2 gap-4">
        {cards.map((card) => (
          <Card key={card.name} className="bg-zinc-900 border-zinc-800">
            <CardHeader>
              <CardTitle className="flex items-center gap-2">
                <CreditCard className="h-5 w-5 text-orange-400" />
                {card.name}
              </CardTitle>
            </CardHeader>
            <CardContent className="space-y-3">
              <div className="flex justify-between text-sm">
                <span className="text-zinc-400">Type</span>
                <span>{card.type}</span>
              </div>
              <div className="flex justify-between text-sm">
                <span className="text-zinc-400">Deposit</span>
                <span>{card.deposit}</span>
              </div>
              <div className="flex justify-between text-sm">
                <span className="text-zinc-400">APR</span>
                <span>{card.apr}</span>
              </div>
              <Button variant="outline" className="w-full mt-2" onClick={() => window.open(card.link, '_blank')}>
                <ExternalLink className="h-4 w-4 mr-2" />
                Apply Now
              </Button>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
}
